import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

/**
 * Giant transparent display word that drifts horizontally on scroll.
 * Used inside a `relative` parent section.
 */
export const BackgroundWord = ({ word, position = "left", speed = 0.3 }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(
    scrollYProgress,
    [0, 1],
    position === "left" ? [-80 * speed * 100, 80 * speed * 100] : [80 * speed * 100, -80 * speed * 100]
  );

  return (
    <div
      ref={ref}
      aria-hidden
      className="absolute inset-0 pointer-events-none overflow-hidden flex items-center"
    >
      <motion.span
        style={{ x }}
        className="font-oswald font-bold uppercase whitespace-nowrap select-none"
        // size + opacity tuned for the "huge faint label" effect
      >
        <span className="text-[12vw] md:text-[18vw] leading-none text-white/[0.025] tracking-tighter">
          {word}
        </span>
      </motion.span>
    </div>
  );
};

export default BackgroundWord;
